import React, { useState, useEffect } from 'react'
import useMobileDetect from 'helpers/mobile-detect'

import styles from './about-box-number.module.scss'

export default function AboutBoxNumber (props) {
  const currentDevice = useMobileDetect()
  const [imageUrl, setImageUrl] = useState('/static/images/about/bg-boxnumber.png')
  const bgImage = 'url(' + imageUrl + ') no-repeat center center  / cover #000000'
  const [numbers] = useState([
    {
      value: '20+',
      title: 'years coaching',
      subTitle: 'experience'
    },
    {
      value: '4x',
      title: 'WORLD MMA TRAINER',
      subTitle: ' OF THE YEAR'
    },
    {
      value: '#1',
      title: 'BESTSELLING book',
      subTitle: 'FOUR TIMES',
      subTitleMobile: '(4 of them!)'
    },
    {
      value: '99.4%',
      valueM: '99%',
      title: 'of members continue',
      subTitle: 'after their program ends'
    }
  ])

  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width < 768) {
      setImageUrl('/static/images/about/bg-mobile-boxnumber.png')
    } else {
      setImageUrl('/static/images/about/bg-boxnumber.png')
    }
  }, [currentDevice.width])

  return (
    <section className={styles['box-number']} style={{ background: bgImage }}>
      <div className='container'>
        <div className='row'>
          {numbers.map((item, index) => {
            return (
              <div key={index} className={styles['box-number__column-item'] + ' col-6 col-md-3'}>
                <h4 className={'number__desktop' + ' number'}>{item.value}</h4>
                <h4 className={'number__mobile' + ' number'}>{item.valueM && item.valueM}</h4>
                <div className={styles['box-number__solid-line'] + ' col-3'}></div>
                <h5>{item.title}</h5>
                <h5 className={'d-none d-md-block'}>{item.subTitle}</h5>
                <h5 className={'d-block d-md-none'}>{item.subTitleMobile}</h5>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
